export default __webpack_public_path__ + "static/media/Spotify_Logo.0c4ae91b.png";